export default __webpack_public_path__ + "static/media/nelly.f8dd164a.png";